import React from "react";
import {
  Table,
  TableContainer,
  TableHead,
  Paper,
  TableCell,
  TableRow,
  TableBody,
  TablePagination,
} from "@material-ui/core";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import queryString from "query-string";
import PropTypes from "prop-types";
import _get from "lodash.get";
import CustomerFeedbackItem from "./item";
import { styles } from "./styles";
const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];
class CustomerFeedbackList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 5,
    };
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.updateUrl = this.updateUrl.bind(this);
  }
  componentDidMount() {}
  handleChangePage(event, page) {
    this.setState({ page: page + 1 });
  }
  handleChangeRowsPerPage(event) {
    this.setState({ page: 1, pageSize: event.target.value });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevPage = prevState.page;
    const prevPageSize = prevState.pageSize;
    if (prevPage !== this.state.page || prevPageSize !== this.state.pageSize) {
      this.updateUrl();
    }
  }
  updateUrl() {
    const { page, pageSize } = this.state;
    this.props.history.push({
      search: queryString.stringify({
        page: page,
        pageSize,
      }),
    });
  }
  render() {
    const { t, classes, list, remove, selectFeedback } = this.props;
    const feedbacks = _get(list, "rows", []);
    const { page, total, pageSize = ROWS_PER_PAGE_OPTIONS[0] } = list;
    return (
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.customCell}>{t("name")}</TableCell>
              <TableCell className={classes.customCell}>{t("email")}</TableCell>
              <TableCell className={classes.customCell}>{t("phone")}</TableCell>
              <TableCell className={classes.customCell}>
                {t("created_at")}
              </TableCell>
              <TableCell align="center">{t("action")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {feedbacks.map((feedback) => {
              return (
                <CustomerFeedbackItem
                  key={feedback._id}
                  feedback={feedback}
                  selectFeedback={selectFeedback}
                  remove={remove}
                />
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
          component="div"
          count={total}
          rowsPerPage={pageSize}
          page={page - 1}
          backIconButtonProps={{
            "aria-label": "previous page",
          }}
          nextIconButtonProps={{
            "aria-label": "next page",
          }}
          onChangePage={(event, page) => {
            this.handleChangePage(event, page);
          }}
          onChangeRowsPerPage={(event) => {
            this.handleChangeRowsPerPage(event);
          }}
          labelRowsPerPage={t("rows_per_page")}
          labelDisplayedRows={({ from, to, count }) => `${from} - ${to} `}
        />
      </TableContainer>
    );
  }
}
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

CustomerFeedbackList.propTypes = {
  list: PropTypes.shape({
    page: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
    rows: PropTypes.arrayOf(PropTypes.object),
  }),
  history: PropTypes.object,
  update: PropTypes.func,
  remove: PropTypes.func,
  uploadAvatar: PropTypes.func,
  selectFeedback: PropTypes.func,
};

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(CustomerFeedbackList)));
